import { closeIcon } from "../../../assets/icons";
import { t } from "i18next";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addEditPopup, resetAddEditPopup } from "../store/actions";
import { addNewCase, resetAddNewCase, resetSearchCase, searchCase } from "../../dashboard/store/actions";
import { Loader } from "../../../components";
import { toast } from "react-toastify";
import { validateTokenBeforeApiCall } from "../../../utils/tokenUtils";

// Functional component for Create case
const CreateCasePopup = (props: any) => {
  const dispatch = useDispatch();

  const popupData: any = useSelector<any>((state) => state.addEditCM);
  const searchCaseData: any = useSelector<any>((state) => state.searchCaseData);
  const addNewCaseData: any = useSelector<any>((state) => state.addNewCaseData);

  const [selectedCase, setSelectedCase] = useState<any>(false);
  const [selectedCaseId, setSelectedCaseId] = useState<any>(null);
  const [searchKey, setSearchKey] = useState<string>("");
  const [listData, setListData] = useState<any>(null);
  const [configData, setConfigData] = useState<any>(null);
  const [enableCreateCase, setEnableCreateCase] = useState<boolean>(true);
  
  const hasDispatchedAddCase = useRef(false);

  useEffect(() => {
    dispatch(addEditPopup({
      token: props.token,
      param: {
        dspId: props.dspId,
        controlId: props.data.controlId
      }
    }))
  }, [dispatch, props.token, props.dspId, props.data.controlId]);

  useEffect(() => {
    if (popupData.isSuccess && popupData.data !== null) {

      setConfigData(popupData.data.popupForm);
      
      dispatch(resetAddEditPopup());
    } else if (popupData.isError) {

      dispatch(resetAddEditPopup());
    }

    if (searchCaseData.isSuccess && searchCaseData.data !== null) {
      setListData(searchCaseData.data);
      setSelectedCaseId(null)
      setEnableCreateCase(false)

      dispatch(resetSearchCase());
    } else if (searchCaseData.isError) {
      if (searchCaseData.data.error.response.status === 404) {
        setListData({ rowCount: 0, emptyMessage: "No records found" })
      } else {
        setListData(null);
      }

      setEnableCreateCase(false);
      setSelectedCaseId(null)
      toast.error(searchCaseData.data.message);
      dispatch(resetSearchCase());
    }

    //We need to use proper error messages (e.g. record already exist 409)
    if (addNewCaseData.isSuccess && hasDispatchedAddCase.current) {
      hasDispatchedAddCase.current = false;
      toast.success(addNewCaseData.data?.message || 'Record added successfully.');
      dispatch(resetAddNewCase());
      props.onSubmit("refereshGrid", null);
    } else if (addNewCaseData.isError && hasDispatchedAddCase.current) {
      hasDispatchedAddCase.current = false;
      const status = addNewCaseData.data?.error?.response?.status;
      let errorMessage = 'Failed to add case';
      if (status === 409) {
        errorMessage = 'Record already exists.';
      } else {
        errorMessage = addNewCaseData.data?.error?.response?.data?.message 
          || addNewCaseData.data?.error?.response?.data 
          || addNewCaseData.data?.message 
          || 'Failed to add case';
      }
      toast.error(errorMessage);
      dispatch(resetAddNewCase());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [popupData, addNewCaseData, searchCaseData, dispatch]);

  // Function to render form iframe
  const _renderFormIframe = () => {
    const iframeUrl = props?.iframeData;

    return (
      <div style={{ width: "100%", height: "80vh" }}>
        <iframe
          src={iframeUrl}
          style={{ width: "100%", height: "100%", border: "none" }}
          title="Form Iframe"
        />
      </div>
    );
  };


  const __renderCases = () => {
    if (searchCaseData.isFetching) {
      return <Loader />
    }

    if (listData !== null && listData.rowCount >= 1) {
      return <div style={{maxHeight: "50vh", overflow:"auto"}}> {listData.gridRows.map((element: any, index: number) => {
        let value = element.values
        return (<div key={"form" + index}>
          <label className="d-flex pb-3">
            <div className="p-3">
              <input type="radio" id={"checkbox" + index} name={"case"} onChange={(e) => setSelectedCaseId(element)} />
            </div>
            <div className="flex-grow-1">
              <p className="m-0"><b>{value[2]}</b> {value[1]}</p>
              <p>{value[4]}</p>
            </div>
          </label>
        </div>)
      })
      }
      </div>
    } else if (listData !== null && listData.rowCount === 0) {
      return <div>{listData.emptyMessage}</div>
    }
  }

  const __onSearchSubmit = async (e: any) => {
    e.preventDefault();

    // Validate token before making API call to prevent crashes
    const isTokenValid = await validateTokenBeforeApiCall();
    if (!isTokenValid) {
      return;
    }

    dispatch(searchCase({
      token: props.token,
      param: {
        dspId: props.dspId,
        controlId: configData.controls.find((item: any) => item.name === "btnSearch").associatedControlId,
        searchKey: searchKey
      }
    }));
    // setSearchKey(e.target.value);

    // dispatch(searchCase({
    //   token: props.token,
    //   param: {
    //     dspId: props.dspId,
    //     controlId: 117,
    //     searchKey: e.target.value
    //   }
    // }));
  }

  const __OnClickSelectCase = async () => {
    if (selectedCaseId !== null) {
      // Validate token before making API call to prevent crashes
      const isTokenValid = await validateTokenBeforeApiCall();
      if (!isTokenValid) {
        return;
      }

      hasDispatchedAddCase.current = true;
      dispatch(addNewCase({
        token: props.token,
        param: {
          dspId: props.dspId,
          scvId: selectedCaseId.values[0],
          oneViewReference: selectedCaseId.values[1]
        }
      }));
    }
  }

  const __onCreateCase = () => {
    setSelectedCase(true);
    props.onSubmit("createCase", null)
  }

  const __renderFormLayout = () => {
    if (configData !== null) {
      return configData.controls.map((item: any, index: number) => {
        switch (item.name) {
          case "search":
            return <input type="text" className="form-control  p-3" placeholder={item.label} onChange={(e: any) => setSearchKey(e.target.value)} style={{color: 'black', fontSize: '15px', fontWeight: '600'}} />;
          case "btnSearch":
            return <button type="submit" className="btn btn-primary">{item.label}</button>;
          default:           
            return null;
        }
      })
    }
  }

  const __renderFooterLayout = () => {
    if (configData !== null) {
      return configData.controls.map((item: any, index: number) => {
        switch (item.name) {
          case "addCase":
            return <div className="flex-grow-1">
              <button className="btn btn-primary" disabled={selectedCaseId !== null ? false : true} onClick={__OnClickSelectCase}>{item.label}</button>
            </div>;
          case "createCase":
            return <div>
              <button className="btn btn-primary" onClick={__onCreateCase}
                disabled={enableCreateCase}
              >{item.label}</button>
            </div>;
          default:
            return null;
        }
      })
    }
  }

  return (
    <div className="xan-modal">
      <div
        className="modal fade show"
        id="exampleModal"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLabel">
                {t("CREATECASESUMMARY")}
              </h5>
              <button
                className="btn btn-transparent close"
                onClick={() => props.onSubmit("", null)}
              >
                <img src={closeIcon} alt="close" />
              </button>
            </div>
            <div className="modal-body">
              {
                popupData.isFetching ? <Loader /> : ""
              }
              {
                !selectedCase ?
                  <div>
                    <div className="pb-3">
                      <form onSubmit={__onSearchSubmit}>
                        <div className="input-group">
                          {__renderFormLayout()}
                        </div>
                      </form>
                    </div>
                    {__renderCases()}

                    <div className="d-flex">
                      {__renderFooterLayout()}


                    </div>
                  </div> :
                  <div className="content-container">{_renderFormIframe()}</div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateCasePopup;
